import { createContext } from 'react';
import { StoryDetailListWrapperContextType } from '#advertStory/detail-list-wrapper';

const StoryDetailListWrapperContext = createContext<StoryDetailListWrapperContextType>(null);

export { StoryDetailListWrapperContext };
